import './header.css';
import manual from "./AR Portal Manual.pdf";
import React, { useContext, useEffect, useState } from 'react';
import { Cookies, useCookies } from 'react-cookie';
import {Nav, Navbar, NavDropdown} from 'react-bootstrap';

export const Header = (props) => {
    const cookies = new Cookies();
    const [data, setData] = useState();

    useEffect(() => {     
        setData(cookies.get('email'));
      }, [data]
      )

    const handleLogOut = (newData) => {
        cookies.remove('email',{path:'/'});
        cookies.remove('isCorporate',{path:'/'});
        cookies.remove('corpName',{path:'/'});
        // cookies.remove('customers',{path:'/'});
        cookies.remove('warehouse',{path:'/'});
        cookies.remove('stores',{path:'/'});
        localStorage.removeItem('storeList');
        localStorage.removeItem('contactEmailList');
        localStorage.removeItem('customers');
        props.validateCookies();
    };

    const openManual = () => {
        
    };

    return (
        <header className="nav-header bannercontainer">
            <div className='row'>
                <div className='col-md-10'><h3 className='sitetitle'><a href="../app/invoice">KGP Customer Portal</a></h3></div>
            </div>
            <div className='row'>
                <div className="col-sm-12">
                    <Navbar bg="dark" variant="dark">
                        <Nav className="me-auto">
                            <Nav.Item className="homeTab">
                                <Nav.Link href="../app/invoice">Home</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link href="../app/contact">Contact Us</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link href={manual} target="_blank">Manual</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Nav>
                            <Nav.Item>
                                <NavDropdown title={`Welcome ${cookies.get('email') ? cookies.get('email') : ""}`} id="collasible-nav-dropdown">
                                <NavDropdown.Item onClick={handleLogOut}>Log Out</NavDropdown.Item>
                                </NavDropdown>
                            </Nav.Item>
                        </Nav>
                    </Navbar>
                </div>
            </div>
        </header>
    );
};